import { BaseButtonType } from '@cplug/design-system/components/props'
import { ref } from 'vue'
import { useFormModalStore } from '@cplug/frontend-core/stores'
import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import ERPFeedbackForm from '../components/organisms/ERPFeedbackForm.vue'
import useMixpanel from '~/shared/composables/useMixpanel'
import { openLegacySistemaHome } from '~/shared/composables/useLegacySSORedirect'

export default function useOpenPreviousVersionModal (title: string, buttonTitle: string): void {
  const formModalStore = useFormModalStore()
  const { user } = useAuthenticationStore()
  const { track } = useMixpanel()

  const feedback = ref('')

  formModalStore.open({
    title,
    content: ERPFeedbackForm,
    contentProps: {
      modelValue: feedback,
      'onUpdate:modelValue': (value: string) => {
        feedback.value = value
      }
    },
    primaryButton: {
      title: buttonTitle,
      type: BaseButtonType.Primary,
      customAction: async () => {
        try {
          track('Previous Version Feedback Submitted', {
            feedback: feedback.value,
            user
          })
        } catch {
        }

        await openLegacySistemaHome()
      }
    }
  })
}
